<template>
  <generic-modal :modal-key="'zero_balance'"
                 :has-extra-modal-class="'popup_box zero_balance modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
      <h1>{{ getTranslations.home_modals_zero_balance_zero_game_balance }}</h1>
      <img src="/static/images/popups/zero_ballance.png" class="zero_bal_img">
      <p> {{ getTranslations.home_modals_zero_balance_unlock_more_games_msg }} </p>
      <button v-if="!hideStore" @click.prevent="toBundlesPage"> {{ getTranslations.home_modals_zero_balance_unlock_games }}</button>
    </template>
  </generic-modal>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import GenericModal from '../sharedcomponents/GenericModal';

export default {
  name: 'zero-balance',
  components: { GenericModal },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ZeroBalance.vue